
import React from 'react'

const CommonContent = ({ children, isDark }: any) => {
	return (
		<div className={`${'commonContent'} ${isDark ? 'darkContent' : ''}`}>
			{children}
		</div>
	)
}

export default CommonContent
